import { useRef } from 'react';
import { Cropper, CropperRef } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css';

interface LogoCropModalProps {
  src: string;
  title?: string;
  onSave: (blob: Blob) => void;
  onCancel: () => void;
}

export function LogoCropModal({ src, title = 'Recortar logo', onSave, onCancel }: LogoCropModalProps) {
  const cropperRef = useRef<CropperRef>(null);

  function handleSave() {
    const canvas = cropperRef.current?.getCanvas({ width: 512, height: 512 });
    canvas?.toBlob(b => b && onSave(b), 'image/png', 0.95);
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
          <p className="text-sm font-semibold text-gray-800">{title}</p>
          <button onClick={onCancel} className="text-gray-400 hover:text-gray-600 text-lg leading-none">&times;</button>
        </div>

        <div style={{ height: 340 }}>
          <Cropper
            ref={cropperRef}
            src={src}
            style={{ height: 340 }}
            stencilProps={{
              grid: true
            }}
          />
        </div>

        <div className="px-5 py-4 border-t border-gray-100 flex justify-end gap-2">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50"
          >
            Cancelar
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 text-sm rounded-lg text-white font-medium bg-primary-600 hover:bg-primary-700"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}
